<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.table">
  <div class="banner center" style="margin-top:10px;max-width: 1200px;">
    <div class="row row_header freeze_col freeze_height">
      <div class="col-5">
        <label style="font-weight: normal; margin-left: 15px;top: 3px; position: relative;float: left;">
          <input type="checkbox" [(ngModel)]="isBlockedOrInactive" [disabled]="isArchive" (change)="onLoad()" />
          <span class="normal_color">Blocked / Inactive</span>
        </label>
        {{localService.languageContent.table.name}}
      </div>
      <div class="col-3">
        {{localService.languageContent.table.contact_num}}
      </div>
      <div class="col-4">
        <label style="font-weight: normal; margin-left: 15px;top: 3px; position: relative;">
          <input type="checkbox" [(ngModel)]="isArchive" [disabled]="isBlockedOrInactive" (change)="onLoad()" />
          <span class="normal_color">&nbsp;</span>
        </label>
        {{localService.languageContent.table.last_activity}}
      </div>
    </div>
    <div class="custom_rows_body" *ngIf="source" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
      <div class="row styled_row freeze_col" *ngFor="let item of source.content.items;index as idx">
        <div class="col-md-5">
          <button class="button_icon button_icon_color" style="top: 5px;" (click)="onClick(0,item.key)">
            more_horiz
          </button>
          <span class="sr_num">{{((source.content.paging.currentPage -1) * source.content.paging.dataPerPage) + (idx +
            1)}}.</span>
          <span [ngClass]="localService.getLanguageCode(item.v4)" style="white-space: nowrap;"
            [ngStyle]="{'color' : item.v1 == '1' || item.v6 == '0' ? 'red' : 'inherit'}">{{item.v3}}</span>
        </div>
        <div class="col-md-3">
          <span class="en">{{item.v7}}</span>
        </div>
        <div class="col-md-4">
          <button class="button_icon button_icon_color" style="top: 5px;"
            [ngStyle]="{'opacity' : item.v5 == '1' ? '0.5' : '1'}"
            (click)="onActiveInactiveStatus(item.key,activeInactiveFor.ArchiveBusiness)">
            {{item.v5 == '1' ? 'unarchive' : 'archive'}}
          </button>
          <span class="en">{{item.v2 | localDate}}</span>
        </div>
      </div>
    </div>
  </div>
  <app-paging *ngIf="source && source.content" [paging]="source.content.paging" [IsShowDateRange]="true"
    (onPagingRefreshed)="onLoad()" (onCountryChanged)="onCountryUpdated($event)"></app-paging>
</div>
<div>
  <app-message-box *ngIf="isOpenConfirmationBox" [IsConfirmationType]="true" (onClose)="onDelete($event)"
    [IsPopup]="true" [message]="confirmationMessage" />
  <app-otp-container *ngIf="isShowOtpPopup" [IsOtpPopup]="true" (onVerified)="onVerifiedOtp($event)"
    [businessId]="selectedBusinessId" [otpType]="selectedOtpType" [interactionType]="interactionType"
    (onCancelled)="isShowOtpPopup = false" />
  <app-more-actions [(isOpenPopup)]="isActionPopupOpen" [items]="moreActionItems" [title]="actionTitle"
    (onClicked)="onMoreActionClicked($event)" />
  <span style="display: none;">
    <button class="on_as_country_changed" (click)="onChangeAsCountry()">As Country Changed</button>
  </span>
</div>